// DirectQuote: in the "Cotizar" modal, the new-customer fields only make sense when no
// existing customer is picked. Hiding them is comfort, not the rule — the server decides
// (it ignores the name when a customer_id comes in, and demands it when it does not), so
// this failing changes nothing but the tidiness of the form.
export class DirectQuote extends HTMLElement {
  connectedCallback(): void {
    const select = this.querySelector<HTMLSelectElement>("[data-direct-customer]");
    const fields = this.querySelector<HTMLElement>("[data-direct-new]");
    const name = fields?.querySelector<HTMLInputElement>("#name");
    if (!select || !fields || !name) return;

    const sync = (): void => {
      const isNew = select.value === "";
      fields.hidden = !isNew;
      // `required` on a hidden field blocks submission with an error nobody can see.
      name.required = isNew;
    };
    select.addEventListener("change", sync);
    sync();
  }
}
